//in-number v.1.0.0 from 21.07.2024

(function(window, document, undefined){
  "use strict";

  // Функция для создания элементов управления количеством
  function createQuantityControls(container) {
    var quantityNav = document.createElement('div');
    quantityNav.className = 'quantity-nav';

    var quantityUp = document.createElement('div');
    quantityUp.className = 'quantity-button quantity-up';
    quantityUp.innerHTML = '<i class="fal fa-plus"></i>';

    var quantityDown = document.createElement('div');
    quantityDown.className = 'quantity-button quantity-down';
    quantityDown.innerHTML = '<i class="fal fa-minus"></i>';

    quantityNav.appendChild(quantityUp);
    quantityNav.appendChild(quantityDown);

    container.appendChild(quantityNav);

    return {
      upButton: quantityUp,
      downButton: quantityDown
    };
  }

  // Функция для обновления стоимости каждого товара
  function updateProductSubtotal(spinner) {
    var input = spinner.querySelector('input[type="number"]');
    var quantity = parseFloat(input.value) || 0;
    var priceElement = spinner.closest('tr').querySelector('.product-price-cart');
    var subtotalElement = spinner.closest('tr').querySelector('.product-subtotal');

    if (priceElement && subtotalElement) {
      var priceText = priceElement.textContent;
      var price = parseFloat(priceText) || 0; // Directly parse the text content as a float
      var subtotal = quantity * price;
      subtotalElement.textContent = subtotal.toFixed(2);
    }
  }

  // Функция для обновления общей суммы всех товаров
  function updateTotal() {
    var totalElement = document.querySelector('#bsk_order_summ');
    var total = 0;

    if (totalElement) {
      document.querySelectorAll('.product-subtotal').forEach(function(subtotalElement) {
        var subtotalText = subtotalElement.textContent;
        total += parseFloat(subtotalText) || 0; // Directly parse the text content as a float
      });
      totalElement.textContent = total.toFixed(2);
    }
  }

  // Функция для обновления общего количества товаров в корзине
  // function updateWishlistItemCount() {
  //   var totalQuantity = 0;

  //   document.querySelectorAll('.quantity input[type="number"]').forEach(function(input) {
  //     totalQuantity += parseFloat(input.value) || 0;
  //   });

  //   var wishlistItemCount = document.querySelector('.wishlist-item-count');
  //   if (wishlistItemCount) {
  //     wishlistItemCount.textContent = totalQuantity;
  //   }
  // }

  // Функция для обновления состояния кнопки оформления заказа
  function updateOrderButtonState() {
    var orderButton = document.querySelector('input[name="subbutOrderForm"]');
    if (orderButton) {
      orderButton.classList.add('btn--disabled');
      orderButton.disabled = true;
      //orderButton.style.display = "none";
    }
  }

  // Функция для изменения цвета кнопки пересчета
  function highlightRecalculateButton() {
    var recalculateButton = document.querySelector('input[name="subbutReLoadOrder"]');
    if (recalculateButton) {
      recalculateButton.classList.add('btn--chery');
    }
  }

  // Функция для замены значений на три тире
  function replaceValuesWithDashes() {
    var saleElement = document.querySelector('#bsk_sale_summ');
    var wholeElement = document.querySelector('#bsk_whole_summ');

    if (saleElement) {
      saleElement.textContent = '---';
    }

    if (wholeElement) {
      wholeElement.textContent = '---';
    }
  }

  // Итерируемся по каждому элементу с классом "quantity"
  document.querySelectorAll('.quantity').forEach(function(spinner) {
    var input = spinner.querySelector('input[type="number"]');
    var min = parseFloat(input.getAttribute('min')) || 0;
    var max = parseFloat(input.getAttribute('max')) || Infinity;

    // Создаем элементы управления
    var controls = createQuantityControls(spinner);
    
    // Обработчик для кнопки увеличения
    controls.upButton.addEventListener('click', function() {
      var oldValue = parseFloat(input.value) || 0;
      var newVal = Math.min(oldValue + 1, max);
      input.value = newVal;
      updateProductSubtotal(spinner); // Обновляем стоимость товара
      updateTotal(); // Обновляем общую сумму после изменения количества
      replaceValuesWithDashes(); // Заменяем значения на три тире
      //updateWishlistItemCount(); // Обновляем общее количество товаров в корзине
      updateOrderButtonState(); // Делаем кнопку оформления заказа серой и некликабельной
      highlightRecalculateButton(); // Изменяем цвет кнопки пересчета
    });

    // Обработчик для кнопки уменьшения
    controls.downButton.addEventListener('click', function() {
      var oldValue = parseFloat(input.value) || 0;
      var newVal = Math.max(oldValue - 1, min);
      input.value = newVal;
      updateProductSubtotal(spinner); // Обновляем стоимость товара
      updateTotal(); // Обновляем общую сумму после изменения количества
      replaceValuesWithDashes(); // Заменяем значения на три тире
      //updateWishlistItemCount(); // Обновляем общее количество товаров в корзине
      updateOrderButtonState(); // Делаем кнопку оформления заказа серой и некликабельной
      highlightRecalculateButton(); // Изменяем цвет кнопки пересчета
    });

    // Обработчик для изменения значения инпута (например, если пользователь вводит количество вручную)
    // input.addEventListener('change', function() {
    //   updateProductSubtotal(spinner); // Обновляем стоимость товара
    //   updateTotal(); // Обновляем общую сумму после изменения количества
    //   replaceValuesWithDashes(); // Заменяем значения на три тире
    //   updateWishlistItemCount(); // Обновляем общее количество товаров в корзине
    //   updateOrderButtonState(); // Делаем кнопку оформления заказа серой и некликабельной
    //   highlightRecalculateButton(); // Изменяем цвет кнопки пересчета
    // });
  });

  // // Инициализация общей суммы и количества при загрузке страницы
  // document.querySelectorAll('.quantity').forEach(function(spinner) {
  //   updateProductSubtotal(spinner); // Обновляем стоимость каждого товара
  // });
  // updateTotal(); // Обновляем общую сумму при загрузке страницы
  // updateWishlistItemCount(); // Обновляем общее количество товаров в корзине при загрузке страницы

})(window, document);